import { render, staticRenderFns } from "./Deleted.vue?vue&type=template&id=54e1b116&"
import script from "./Deleted.vue?vue&type=script&lang=js&"
export * from "./Deleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports